import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./components/language/en.json";
import fr from "./components/language/fr.json";
import ar from "./components/language/ar.json";
import { decryptAEStoString } from "./utils/utilities";

// Function to get the stored language or fallback to 'en'
const getStoredLanguage = () => {
  const storedLang = localStorage.getItem("languageChange");
  return storedLang ? decryptAEStoString(storedLang) : "en"; // Ensure fallback
};

// Initialize i18n
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    ar: { translation: ar },
  },
  lng: getStoredLanguage(), // Dynamically set language
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
